import { gsap, Power2 } from 'gsap'
import {loadElementLottie, playLottie} from './lottie'
import { goToHash } from './go-to-hash'
import {getCookie, setCookie} from "./cookies"
import { heroAnimationsAfterLoader } from "../blocks/hero-slider"

let preloaderPage = $('#preloader')

if (preloaderPage.length) {

  setCookie('preloader_showed_'+ preloaderPage.data('page-name'))

  setTimeout(function(){
    loadElementLottie($('.js-preloader-lottie'))
  }, 10)



  let globalHash = window.location.hash
  if (globalHash) goToHash(globalHash)

  // let tl = new gsap.timeline()
  // tl.to('.js-preloader-progress', {top: 0, duration: 0.4, opacity: 1,})


  let pageLoaded = 0
  let minimumPreloadTimeCompleted = 0
  let minimumPreloadTime = 2500

  function runPageLoadedFunctions() {
    if (!pageLoaded) return false
    if (!minimumPreloadTimeCompleted) return false

    gsap.to('.js-preloader-logo', {top: '50vh', duration: 1})
    //gsap.to('.js-preloader-progress', {opacity: 0, scale: 0.4, duration: 0.4})


    gsap.fromTo('#preloader', {
      yPercent: 0
    }, {
      yPercent: -100,
      duration: 1,
      onComplete: () => {

        $('#preloader').remove()

        // heroAnimationsAfterLoader()

      }
    })

    setTimeout(function(){
      heroAnimationsAfterLoader()
    }, 0)

  }

  $(window).on('load', function () {
    pageLoaded = 1
    runPageLoadedFunctions()
    //setCookie('preloader_showed_' + preloaderPage.data('page-name'))
  })

  setTimeout(function () {
    minimumPreloadTimeCompleted = 1
    runPageLoadedFunctions()
  }, minimumPreloadTime)


} else {
  setTimeout(function(){
    heroAnimationsAfterLoader()
  }, 400)
}
